import { Alert as MAlert, AlertProps } from '@mui/material'

export const Alert: React.FC<AlertProps> = (props) => {
  return <MAlert {...props} />
}
